// extracted by mini-css-extract-plugin
export var Img = "projects-module--Img--FyE07";
export var card = "projects-module--card--EIPJt";
export var container = "projects-module--container--fvm6N";
export var left = "projects-module--left--JM5ix";
export var link = "projects-module--link--rY8Xv";
export var right = "projects-module--right--kNKh5";
export var rightContent = "projects-module--rightContent--CiTN9";